import { gql, useQuery } from '@apollo/client';

// 邮编位置信息类型定义
export interface ZipcodeLocationType {
  zipcode: string;
  latitude?: number;
  longitude?: number;
}

// GraphQL查询响应类型
export interface GetDeliveringZipcodesByDriverAccountIdQuery {
  getDeliveringZipcodesByDriverAccountId: ZipcodeLocationType[];
}

// 根据司机ID获取派送中数据的zipCode列表
export const GET_DELIVERING_ZIPCODES_BY_DRIVER_ACCOUNT_ID = gql`
  query GetDeliveringZipcodesByDriverAccountId {
    getDeliveringZipcodesByDriverAccountId {
      zipcode
      latitude
      longitude
    }
  }
`;

// Hook for getting delivering zipcodes by driver account ID
export const useGetDeliveringZipcodesByDriverAccountId = () => {
  return useQuery<GetDeliveringZipcodesByDriverAccountIdQuery>(
    GET_DELIVERING_ZIPCODES_BY_DRIVER_ACCOUNT_ID
  );
};
